import { Box, Paper, Typography } from '@mui/material'
import { colors, borderRadius, sxPresets } from '@/theme'
import FetchScr from './fetchScr'

export default function SCRData() {
  return (
    <Paper
      id='scr-data'
      elevation={1}
      sx={{ border: `1px solid ${colors.border.default}`, borderRadius: borderRadius.lg, overflow: 'hidden' }}
    >
      {/* Header */}
      <Box sx={sxPresets().section.header}>
        <Box>
          <Typography variant='sectionTitle'>SCR Data</Typography>
        </Box>
        <FetchScr />
      </Box>
    </Paper>
  )
}
